import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const rerunAutoSplit = {
  name: "rerunAutosplit" as const,
  input: z.object({ fulfillmentGroupIds: z.array(zExt.objectId()) }),
  output: z.object({ success: z.boolean(), message: z.string().nullish() }),
};
